export default __webpack_public_path__ + "static/media/anagrafica_gruppi.83c5536b.less";